<template>
	<div >
		<a-modal id='warp_sub' width='31rem' v-model="ishand" @cancel="handleCancel" :footer="null"
			:keyboard='false' :maskClosable='false'>
			<div solt='title' class='warp_title'>新股確認</div>
			<div class='warp_body'>
				<a-form-model ref='ruleForms' :model="formmin" labelAlign='left' layout="inline" :rules='rules'
					hideRequiredMark>
					<div id='on-center'>
						<a-form-model-item label="保薦機構" prop='info'>
							<a-textarea v-model="formmin.info" :auto-size="{ minRows: 4, maxRows: 5 }"
								style='width: 23.2rem;' :maxLength='200' placeholder="多個保薦機構請用分號分隔" class='warp_width' />
							<!-- <span
								style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{formmin.info.length}}/200</span> -->
						</a-form-model-item>
					</div>
				</a-form-model>
			</div>
			<div class='warp_button' style="display:flex;align-items: center;margin: 1rem auto;">
				<button type="button" class="qxBtn" @click='handleCancel'>取消</button>
				<button type="button" class="qdBtn" @click="handleOk('ruleForms')" :loading="loading">确定</button>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: ['ishand','forms'],
		data() {
			return {
				formmin:{
					info:this.forms.baojianr
				},
				loading:false,
				rules:{
					
				}
			}
		},
		watch:{
			forms:{
				
			}
		},
		mounted() {
			console.log(this.ishand,this.forms.baojianr)
		},
		methods: {
			handleCancel(){
				this.$emit('child',false)
			},
			handleOk(){
				console.log(this.formmin.info)
				if(this.formmin.info){
					this.$emit('child',false,this.formmin)
				}
				
			}
		}
	}
</script>

<style lang='scss'>
	/* #uplode{
	
		.ant-modal-wrap{
			z-index: 2000;
		}
		
		.warp_button {
			width: 80%;
			margin: 0 auto;
			overflow: hidden;
		}
		
		.qxBtn,
		.qdBtn {
			width: 9rem;
			height: 2.5rem;
			color: #fff;
			outline: none;
			border: 0;
			border-radius: 5px;
			font-size: 0.8rem;
		}
		
		.qxBtn {
			background-color: #c8c8c8;
		}
		
		.qdBtn {
			background-color: rgb(59, 199, 161);
			margin-left: auto;
		}
	} */
</style>
